
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import {Link} from "react-router-dom";
import ArrowIcon from '@material-ui/icons/ArrowForward';
import stripeImage from '../../assets/onboarding/powered_by_stripe.png'

import { connect } from 'react-redux';
import { getShopInfoAction, getShopStripeIdAction } from '../../actions/ShopInfo';
import { createStripeAccountAction } from '../../actions/CreateStripeAccount';
import SaveStepButton from './SaveStepButton';
import { MixpanelTrack } from '../../util/MixpanelHelper';
import selectors from '../../reducers/selectors';

class SetupPayments extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isSetup: false,
            url: '',
            isLoading: true,
            hasError: false,
            errorMessage: ''
        }

    }

    componentDidMount() {
        // First check if Stripe is already set up
        this.props.getShopStripeIdAction(this.props.shopId,
            (resp) => {
                console.log('resp payments', resp)
                if(resp != '') {
                    this.setState({isSetup: true, isLoading: false})
                } else {
                    // If not set up, create Stripe account
                    this.createStripeAccount()
                }
            },
            (error) => {
                console.log('error', error)
                // If error, still try to create Stripe account
                this.createStripeAccount()
            })
    }

    createStripeAccount = () => {
        this.props.getShopInfoAction(this.props.shopId,
            (shopResp) => {
                const shopDetails = {
                    shop_id: this.props.shopId,
                    business_name: shopResp.shopName,
                    first_name: shopResp.ownerName,
                    email: shopResp.ownerEmail,
                    phone_number: shopResp.phoneNumber
                }

                this.props.createStripeAccountAction(shopDetails,
                    (stripeResp) => {
                        console.log('Stripe account created:', stripeResp)
                        
                        // Check if onboarding_url exists in the response
                        if (stripeResp && stripeResp.onboarding_url) {
                            this.setState({
                                url: stripeResp.onboarding_url,
                                isLoading: false
                            })
                        } else {
                            console.error('No onboarding_url in response')
                            console.error('Full response:', stripeResp)
                            this.setState({
                                isLoading: false,
                                hasError: true,
                                errorMessage: 'Unable to get Stripe onboarding URL. Please try again.'
                            })
                        }
                    },
                    (error) => {
                        console.error('Failed to create Stripe account:', error)
                        this.setState({
                            isLoading: false,
                            hasError: true,
                            errorMessage: 'An error occurred while setting up your Stripe account. Please try again.'
                        })
                    }
                )
            },
            (error) => {
                console.log('error getting shop info', error)
                this.setState({
                    isLoading: false,
                    hasError: true,
                    errorMessage: 'An error occurred while getting shop information. Please try again.'
                })
            }
        )
    }

    render() {
        const {activeStep} = this.props
        
        return <div className="tab-pane" id="tab2-4">
                    <div className="d-flex row justify-content-center">
                        <h3 className="title text-primary">Connect your CoffeePass account to Stripe</h3>
                        <p className="title">We use Stripe to make sure you get paid on time and keep your personal and bank details secure.</p>
                        {(this.state.isSetup)?
                            <h3 className="title text-primary">You're all set with your Stripe Account!</h3>
                            :
                            this.state.hasError ?
                                <div style={{marginTop: 20, marginBottom: 20}}>
                                    <div style={{color: 'red', textAlign: 'center'}}>
                                        <h4>Error</h4>
                                        <p>{this.state.errorMessage}</p>
                                        <Button 
                                            color="primary" 
                                            variant="raised" 
                                            onClick={() => {
                                                this.setState({isLoading: true, hasError: false, errorMessage: ''})
                                                this.createStripeAccount()
                                            }}
                                        >
                                            Try Again
                                        </Button>
                                    </div>
                                </div>
                                :
                                this.state.isLoading ?
                                    <div style={{marginTop: 20, marginBottom: 20}}>
                                        <Button color="primary" variant="raised" disabled>
                                            Setting up Stripe...
                                        </Button>
                                    </div>
                                    :
                                    <a href={this.state.url} target="_blank" rel="noopener noreferrer" onClick={() => MixpanelTrack('Clicked Setup Payments on Stripe')}>
                                        <Button color="primary" variant="raised" style={{marginTop: 20, marginBottom: 20}}>
                                            Setup Payments on Stripe
                                            <ArrowIcon />
                                        </Button>
                                    </a>
                        }
                    </div>
                    <img src={stripeImage} />
                    <div className="col-md-12 col-12" style={styles.buttonContainer}>
                        <SaveStepButton {...this.props}
                            activeStep={activeStep}
                            isStateDifferent={() => {}} 
                            onSaveClicked={() => {}}
                            isLoadingSave={false}
                            onDialogYesClicked={(handleNext)=> handleNext()} />
                    </div>
                </div>
    }
}

const styles = {
    buttonContainer: {
        display: 'flex', 
        justifyContent: 'flex-end'
    }
}

const mapStateToProps = state => {
    return {
        shop: selectors(state).shop,
        shopId: selectors(state).shopId
    }
}
const actionCreators = {
    getShopInfoAction,
    getShopStripeIdAction,
    createStripeAccountAction
}

export default connect(
    mapStateToProps,
    actionCreators
)(SetupPayments)